import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { setOpenStreamCamera } from "../../../../Redux/Actions/VideoStreamingActions";
import RealTimeStreaming from "../RealTimeStreaming";

const IPCameraVideoStreamingContainer = ({ page, setPage, socket }) => {
  const { videoStreamAvsChannelList } = useSelector(
    (state) => state?.videoStreamData
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (videoStreamAvsChannelList.length == 0) {
      setOpenStreamCamera(dispatch, false);
    }
  }, [videoStreamAvsChannelList]);

  return (
    <>
      <RealTimeStreaming setPage={setPage} />
      {/* <Footer
        playerRef={playerRef}
        refArray={refArray}
        socket={socket}
        loadingButton={loadingButton}
        setLoadingButton={setLoadingButton}
      /> */}
    </>
  );
};

export default IPCameraVideoStreamingContainer;
